import { getTabTool, getAppImplementation, patchTask } from '@fno/service/api/tasks.js'
import { preFormMutator, preSaveMutator, getKeypath, preChangeMutator, nextHandler, previousHandler } from '@fno/route/hello/task/helpers.js'
import template from './AppNaming.svelte'
import genericChange from '@fno/lib/form/generic-change.js'
import genericReset from '@fno/lib/form/generic-reset.js'
import genericSave from '@fno/lib/form/generic-save.js'
import appImplementationSchema from 'fanx-schema/resource/taskAppImplementation'
import tabToolSchema from 'fanx-schema/resource/taskTabTool'
import transformApiResponseToFormObject from '@fno/lib/transform-api-response-to-form-object.js'
import setContextOriginal from '@fno/lib/form/set-context-original.js'

const page = {
    schoolOnboarding: {
        type: Object,
        schema: appImplementationSchema,
        patch: (task) => patchTask({ task })
    },
    clientOnboarding: {
        type: Object,
        schema: tabToolSchema,
        patch: (task) => patchTask({ task })
    }
}

export default (parent, stateRouter) => {
    const name = `${parent}.appNaming`

    stateRouter.addState({
        name,
        route: '/appNaming',
        template,
        data: {
            title: 'App Naming | T.A.B.'
        },
        resolve: async (ignore, { schoolId }) => {
            const [ schoolOnboarding, clientOnboarding ] = await Promise.all([
                getAppImplementation({ schoolId }),
                getTabTool({ schoolId })
            ])

            return setContextOriginal(
                {
                    context: {
                        form: {
                            schoolOnboarding: transformApiResponseToFormObject({
                                schema: appImplementationSchema,
                                data: schoolOnboarding
                            }),
                            clientOnboarding: transformApiResponseToFormObject({
                                schema: tabToolSchema,
                                data: clientOnboarding
                            })
                        }
                    }
                },
                preFormMutator
            )
        },
        activate: ({ domApi: component, parameters: { schoolId } }) => {
            const save = genericSave({ component, page, preSaveMutator, preFormMutator })
            component.$on('nextStepClicked', nextHandler({
                stateRouter,
                component,
                save,
                schoolId,
                stepId: 'APP_NAMING',
                nextId: 'affiliations'
            }))
            component.$on('previousStepClicked', previousHandler(stateRouter, 'contactInfo', schoolId))
            component.$on('reset', genericReset({ component }))
            component.$on('save', genericSave({ component, page, preSaveMutator, preFormMutator }))
            component.$on('change', genericChange({ component, page, getKeypath, preChangeMutator }))
        }
    })
}
